import React, { useState, useEffect, useRef } from "react";
import client from "../contentfulClient";
import { format, parseISO } from "date-fns";
import { getConfig } from "../helpers/auth-helper";
import { getSrcPath } from "../helpers/auth-helper";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
let process = {
  env: {}
};
const AllRaffles = _ref => {
  let {
    navigate
  } = _ref;
  const headerConfig = getConfig();
  const hostSrc = getSrcPath();
  const [activehistoryType, setActiveIndex] = useState(0);
  const [memberRaffles, setMemberRaffles] = useState([]);
  const [bitData, setBitData] = useState([]);
  const [skeletonLoading, setSkeletonLoading] = useState(true);
  const [raffleCardImage, setRaffleCardImage] = useState([]);
  const [posts, setPosts] = useState([]);
  const [nextUrl, setNextUrl] = useState(null);
  let memberId = localStorage.getItem("memberId");
  useEffect(() => {
    const fetchPostById = async () => {
      try {
        var _entry$fields;
        const entry = await client.getEntry("6m20eSqA4lgcTn6mMSHcmD");

        // Check for linked assets or entries and resolve them
        const resolveLinks = async fields => {
          const resolvedFields = {
            ...fields
          };
          for (const key in fields) {
            const field = fields[key];
            if (Array.isArray(field)) {
              resolvedFields[key] = await Promise.all(field.map(async item => {
                if (item.sys && item.sys.type === "Link") {
                  return await client.getAsset(item.sys.id); // Resolve linked assets
                }
                return item;
              }));
            } else if (field.sys && field.sys.type === "Link") {
              if (field.sys.linkType === "Asset") {
                resolvedFields[key] = await client.getAsset(field.sys.id);
              } else if (field.sys.linkType === "Entry") {
                resolvedFields[key] = await client.getEntry(field.sys.id);
              }
            }
          }
          return resolvedFields;
        };
        const resolvedFields = await resolveLinks(entry.fields);
        setPosts({
          ...entry,
          fields: resolvedFields
        });
        // console.log({ ...entry, fields: resolvedFields });
        setRaffleCardImage((_entry$fields = {
          ...entry,
          fields: resolvedFields
        }) === null || _entry$fields === void 0 || (_entry$fields = _entry$fields.fields) === null || _entry$fields === void 0 || (_entry$fields = _entry$fields.raffleCardBlue) === null || _entry$fields === void 0 || (_entry$fields = _entry$fields.fields) === null || _entry$fields === void 0 || (_entry$fields = _entry$fields.file) === null || _entry$fields === void 0 ? void 0 : _entry$fields.url);
      } catch (error) {
        console.error("Error fetching the post:", error);
      }
    };
    fetchPostById();
  }, []);
  const tabRefs = useRef([]);
  useEffect(() => {
    getRaffles({
      bitStatus: "AVAILABLE,USED,PARTIAL_USED"
    });
  }, []);
  const toggleFilter = index => {
    setSkeletonLoading(true);
    setActiveIndex(index);
    if (index == 0) {
      var _posts$fields;
      getRaffles({
        bitStatus: "AVAILABLE,USED,PARTIAL_USED"
      });
      setRaffleCardImage(posts === null || posts === void 0 || (_posts$fields = posts.fields) === null || _posts$fields === void 0 || (_posts$fields = _posts$fields.raffleCardBlue) === null || _posts$fields === void 0 || (_posts$fields = _posts$fields.fields) === null || _posts$fields === void 0 || (_posts$fields = _posts$fields.file) === null || _posts$fields === void 0 ? void 0 : _posts$fields.url);
      scrollToTop();
    } else if (index == 1) {
      var _posts$fields2;
      getRaffles({
        bitStatus: "CANCELLED"
      });
      setRaffleCardImage(posts === null || posts === void 0 || (_posts$fields2 = posts.fields) === null || _posts$fields2 === void 0 || (_posts$fields2 = _posts$fields2.raffleCardGrey) === null || _posts$fields2 === void 0 || (_posts$fields2 = _posts$fields2.fields) === null || _posts$fields2 === void 0 || (_posts$fields2 = _posts$fields2.file) === null || _posts$fields2 === void 0 ? void 0 : _posts$fields2.url);
      scrollToTop();
    }
  };
  const getRaffles = async params => {
    let bitStatusParam = "";
    if (params.bitStatus && params.bitStatus != "all") {
      bitStatusParam = "&status=".concat(params.bitStatus);
    }
    const url = hostSrc + "/bolapi/v3/members/".concat(memberId, "/privileges?cdc=Raffle").concat(bitStatusParam, "/");
    const headers = headerConfig;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: headers
      });
      setNextUrl(response.headers.get("Next"));
      let filteredData = await response.json();
      let bitReference = filteredData.map(item => item.bit_reference);
      try {
        const fetchPromises = bitReference.map(endpoint => fetch(hostSrc + "/bolapi/v1/bits/?member_id=".concat(memberId, "&bit_id=") + endpoint, {
          method: "GET",
          headers: headers
        }).then(res => res.json()));
        const responses = await Promise.all(fetchPromises);
        // console.log(responses);
        setBitData(responses);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setMemberRaffles(filteredData);
      setSkeletonLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    scrollToTop();
  }, []);
  const nextCall = async nexturl => {
    const url = nexturl;
    const headers = headerConfig;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: headers
      });
      setNextUrl(response.headers.get("Next"));
      let filteredData = await response.json();
      let bitReference = filteredData.map(item => item.bit_reference);
      try {
        const fetchPromises = bitReference.map(endpoint => fetch(hostSrc + "/bolapi/v1/bits/?member_id=".concat(memberId, "&bit_id=") + endpoint, {
          method: "GET",
          headers: headers
        }).then(res => res.json()));
        const responses = await Promise.all(fetchPromises);
        // console.log(responses);
        setBitData([...bitData, ...responses]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setMemberRaffles([...memberRaffles, ...filteredData]);
      setSkeletonLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "all-raffles-container"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: " #131e1e",
      position: "sticky",
      top: "0px",
      zIndex: "2",
      padding: "40px 0 15px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading"
  }, "All\xA0", /*#__PURE__*/React.createElement("p", null, "Raffles")), /*#__PURE__*/React.createElement("div", {
    className: "tab-container"
  }, ["active", "expired"].map((label, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    ref: el => tabRefs.current[index] = el,
    className: activehistoryType === index ? "tab selected-tab" : "tab",
    onClick: () => toggleFilter(index)
  }, label)))), /*#__PURE__*/React.createElement("div", {
    className: "all-raffles-container-2"
  }, skeletonLoading ? /*#__PURE__*/React.createElement("div", {
    style: {
      width: "350px",
      margin: "auto",
      padding: "20px 0"
    }
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 165,
    width: 342,
    borderRadius: 10,
    count: 1,
    style: {
      opacity: "0.2"
    }
  })) : memberRaffles.length > 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: "25px"
    }
  }, memberRaffles.map((item, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "slide"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "190px",
      maxWidth: "340px",
      width: "100%",
      backgroundImage: "url(".concat(raffleCardImage, ")"),
      backgroundSize: "100% 190px",
      backgroundRepeat: "no-repeat",
      flexDirection: "column",
      gap: "25px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      width: "270px",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "188px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "10px",
      letterSpacing: "1px",
      opacity: "60%",
      fontWeight: "500",
      paddingBottom: "2px"
    }
  }, "RAFFLE COLLECTED FOR:"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "12px",
      fontWeight: "400",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden"
    }
  }, "Spending at ", bitData[index][0].sponsor_name, "!")), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "32px"
    }
  }, /*#__PURE__*/React.createElement("img", {
    style: {
      maxWidth: "32px",
      maxHeight: "32px",
      borderRadius: "100%"
    },
    src: bitData[index][0].sponsor_logo
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      width: "270px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "136px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "10px",
      letterSpacing: "1px",
      opacity: "60%",
      fontWeight: "500",
      paddingBottom: "3px"
    }
  }, "STATUS"), /*#__PURE__*/React.createElement("div", {
    className: item.status == "AVAILABLE" || item.status == "PARTIAL_USED" ? "activeCta" : item.status == "USED" ? "winnerCta" : "expiredCta"
  }, item.status == "AVAILABLE" || item.status == "PARTIAL_USED" ? "ACTIVE" : item.status == "USED" ? "WINNER" : "EXPIRED")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "10px",
      letterSpacing: "1px",
      opacity: "60%",
      fontWeight: "500",
      paddingBottom: "2px"
    }
  }, "TRANSACTION DATE"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "12px",
      fontWeight: "400"
    }
  }, new Intl.DateTimeFormat("en-US", {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric"
  }).format(new Date(bitData[index][0].h_bit_date))))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      width: "270px",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "10px",
      letterSpacing: "1px",
      opacity: "60%",
      fontWeight: "500",
      paddingBottom: "2px"
    }
  }, "TICKET ID"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "12px",
      fontWeight: "600",
      color: "#F1CB83"
    }
  }, "#", item.privilege_code))))))), nextUrl && nextUrl != "None" && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "fit-content",
      margin: "auto",
      cursor: "pointer",
      color: "#F1CA83",
      opacity: "1",
      lineHeight: "40px",
      borderRadius: "20px",
      fontWeight: "400",
      padding: "0 20px",
      letterSpacing: "0.5px"
    },
    onClick: () => nextCall(nextUrl)
  }, "View More Raffles", /*#__PURE__*/React.createElement("img", {
    style: {
      transform: "rotate(90deg)",
      width: "20px",
      marginLeft: "5px"
    },
    className: "transactions-logo",
    src: "https://d3hc1c528irei0.cloudfront.net/ui/rightarrow.png"
  })))) : /*#__PURE__*/React.createElement("div", {
    style: {
      width: "fit-content",
      margin: "70px auto 15px",
      padding: "60px",
      border: "1px dashed rgb(173, 173, 173)",
      borderRadius: "10px",
      backgroundColor: "rgba(246, 246, 246, 0.2)"
    }
  }, "No Raffles Available") // Safe fallback content
  ));
};
export { AllRaffles };